// components/layout/Sidebar.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState(['dashboards', 'crm']); // CRM expandido por padrão

  const toggleMenu = (menuKey) => {
    setExpandedMenus(prev => 
      prev.includes(menuKey) 
        ? prev.filter(key => key !== menuKey)
        : [...prev, menuKey]
    );
  };

  const menuItems = [
    {
      key: 'dashboards',
      label: 'Dashboards',
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      hasSubmenu: true,
      subItems: [
        {
          key: 'service-orders',
          label: 'Ordens de Serviço',
          path: '/dashboard/service-orders',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          )
        },
        {
          key: 'sales-orders',
          label: 'Pedidos de Venda',
          path: '/dashboard/sales-orders',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </svg>
          )
        },
        {
          key: 'financial',
          label: 'Financeiro',
          path: '/dashboard/financial',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
            </svg>
          ),
          disabled: true
        },
        {
          key: 'analytics',
          label: 'Análises',
          path: '/dashboard/analytics',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          ),
          disabled: true
        }
      ]
    },
    // 🆕 NOVA SEÇÃO: CRM
    {
      key: 'crm',
      label: 'CRM',
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      hasSubmenu: true,
      subItems: [
        {
          key: 'crm-opportunities',
          label: 'Oportunidades',
          path: '/dashboard/crm-opportunities',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          ),
          isNew: true // Marcar como nova funcionalidade
        },
        {
          key: 'crm-budgets',
          label: 'Orçamentos',
          path: '/dashboard/crm-budgets',
          icon: (
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          ),
          isNew: true // Marcar como nova funcionalidade
        }
      ]
    },
    {
      key: 'integrations',
      label: 'Integrações',
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a1 1 0 01-1-1V9a1 1 0 011-1h1a2 2 0 100-4H4a1 1 0 01-1-1V4a1 1 0 011-1h3a1 1 0 001-1z" />
        </svg>
      ),
      path: '/integrations',
      disabled: true
    },
    {
      key: 'settings',
      label: 'Configurações',
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      path: '/settings',
      disabled: true
    }
  ];

  const handleNavigation = (item) => {
    if (item.disabled) return;
    if (item.path) {
      navigate(item.path);
    }
  };

  const isActiveItem = (item) => {
    return location.pathname === item.path;
  };

  const isActiveParent = (parentItem) => {
    if (!parentItem.subItems) return false;
    return parentItem.subItems.some(subItem => location.pathname === subItem.path);
  };

  return (
    <aside style={{
      position: 'fixed',
      top: '64px',
      left: 0,
      height: 'calc(100vh - 64px)',
      width: isOpen ? '280px' : '70px',
      backgroundColor: '#ffffff',
      borderRight: '1px solid #e5e7eb',
      transition: 'width 0.3s ease',
      zIndex: 999,
      overflowY: 'auto',
      overflowX: 'hidden'
    }}>
      <div style={{ padding: '1rem 0' }}>
        {menuItems.map((item) => (
          <div key={item.key} style={{ marginBottom: '0.5rem' }}>
            {/* Menu Principal */}
            <div
              onClick={() => item.hasSubmenu ? toggleMenu(item.key) : handleNavigation(item)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.75rem 1rem',
                margin: '0 0.75rem',
                borderRadius: '8px',
                cursor: item.disabled ? 'not-allowed' : 'pointer',
                backgroundColor: (isActiveParent(item) && !item.hasSubmenu) || (item.path && isActiveItem(item)) 
                  ? '#eff6ff' : 'transparent',
                color: item.disabled ? '#9ca3af' : 
                       (isActiveParent(item) && !item.hasSubmenu) || (item.path && isActiveItem(item)) 
                       ? '#2563eb' : '#374151',
                opacity: item.disabled ? 0.5 : 1,
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                if (!item.disabled) {
                  e.currentTarget.style.backgroundColor = 
                    (isActiveParent(item) && !item.hasSubmenu) || (item.path && isActiveItem(item)) 
                      ? '#eff6ff' : '#f3f4f6';
                }
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 
                  (isActiveParent(item) && !item.hasSubmenu) || (item.path && isActiveItem(item)) 
                    ? '#eff6ff' : 'transparent';
              }}
            >
              <div style={{ 
                minWidth: '20px', 
                display: 'flex', 
                justifyContent: 'center' 
              }}>
                {item.icon}
              </div>
              
              {isOpen && (
                <>
                  <span style={{
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}>
                    {item.label}
                  </span>
                  
                  {item.hasSubmenu && (
                    <svg 
                      width="16" 
                      height="16" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                      style={{
                        marginLeft: 'auto',
                        transform: expandedMenus.includes(item.key) ? 'rotate(90deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease'
                      }}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  )}
                </>
              )}
            </div>

            {/* Submenu */}
            {item.hasSubmenu && isOpen && expandedMenus.includes(item.key) && (
              <div style={{ 
                marginTop: '0.25rem',
                paddingLeft: '1rem'
              }}>
                {item.subItems.map((subItem) => (
                  <div
                    key={subItem.key}
                    onClick={() => handleNavigation(subItem)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.625rem 1rem',
                      margin: '0 0.75rem',
                      borderRadius: '6px',
                      cursor: subItem.disabled ? 'not-allowed' : 'pointer',
                      backgroundColor: isActiveItem(subItem) ? '#dbeafe' : 'transparent',
                      color: subItem.disabled ? '#9ca3af' : 
                             isActiveItem(subItem) ? '#1e40af' : '#6b7280',
                      opacity: subItem.disabled ? 0.5 : 1,
                      borderLeft: isActiveItem(subItem) ? '3px solid #3b82f6' : '3px solid transparent',
                      transition: 'all 0.2s ease',
                      fontSize: '0.875rem',
                      position: 'relative'
                    }}
                    onMouseOver={(e) => {
                      if (!subItem.disabled) {
                        e.currentTarget.style.backgroundColor = 
                          isActiveItem(subItem) ? '#dbeafe' : '#f9fafb';
                      }
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 
                        isActiveItem(subItem) ? '#dbeafe' : 'transparent';
                    }}
                  >
                    <div style={{ 
                      minWidth: '16px', 
                      display: 'flex', 
                      justifyContent: 'center',
                      marginLeft: '0.25rem'
                    }}>
                      {subItem.icon}
                    </div>
                    
                    <span style={{
                      fontWeight: isActiveItem(subItem) ? '500' : '400',
                      whiteSpace: 'nowrap',
                      flex: 1
                    }}>
                      {subItem.label}
                    </span>
                    
                    {/* Badge "Novo" */}
                    {subItem.isNew && (
                      <span style={{
                        backgroundColor: '#8b5cf6',
                        color: 'white',
                        fontSize: '0.625rem',
                        fontWeight: '600',
                        padding: '0.125rem 0.375rem',
                        borderRadius: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        marginLeft: '0.5rem'
                      }}>
                        Novo
                      </span>
                    )}
                    
                    {subItem.disabled && (
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#9ca3af',
                        marginLeft: 'auto',
                        fontStyle: 'italic'
                      }}>
                        Em breve
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Footer do Sidebar */}
      {isOpen && (
        <div style={{
          position: 'absolute',
          bottom: '1rem',
          left: '1rem',
          right: '1rem',
          padding: '0.75rem',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem'
          }}>
            <div style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#10b981',
              borderRadius: '50%'
            }}></div>
            <span style={{
              fontSize: '0.75rem',
              fontWeight: '500',
              color: '#059669'
            }}>
              API M8 Conectada
            </span>
          </div>
          <p style={{
            fontSize: '0.75rem',
            color: '#64748b',
            margin: 0,
            lineHeight: '1.4'
          }}>
            Sistema integrado e funcionando
          </p>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;